import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-incorrect-url',
  templateUrl: './incorrect-url.component.html',
  styleUrls: ['./incorrect-url.component.css']
})
export class IncorrectUrlComponent implements OnInit, OnDestroy {

  constructor() {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

}
